import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=6adea885&scoped=true"
import script from "./PermissionManager.vue?vue&type=script&lang=js"
export * from "./PermissionManager.vue?vue&type=script&lang=js"
import style0 from "./PermissionManager.vue?vue&type=style&index=0&id=6adea885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adea885",
  null
  
)

export default component.exports